import { useMutation } from '@tanstack/react-query';

import { PREFIX_URL } from '@/src/api/config';
import { axios } from '@/src/lib/axios/axios';
import { MutationConfig } from '@/src/lib/react-query/react-query';
import { generateRoutePath } from '@/src/routes';

const url = `${PREFIX_URL}/projects/:projectId/library/members/:memberId`;

type AddLibraryMemberResponse = { status: boolean };
type AddLibraryMemberDTO = {
  memberId: number;
  projectId: number;
};

export const addLibraryMember = ({
  memberId,
  projectId,
}: AddLibraryMemberDTO): Promise<AddLibraryMemberResponse> => {
  const URL = generateRoutePath(url, { projectId, memberId });

  return axios.post(URL);
};

type UseAddLibraryMemberOptions = {
  config?: MutationConfig<typeof addLibraryMember>;
};

export const useAddLibraryMember = ({ config }: UseAddLibraryMemberOptions = {}) => {
  return useMutation({
    ...config,
    mutationFn: (props) => addLibraryMember(props),
  });
};
